<template>
  <div class="s-web" ref="sWeb">
    <div class="darg-wrap">
      <drag>       
        <div class="work" slot='uLeft' @click="chooseScreenLeft">
          <k-header :headerData="headerTeacher" :class="{negScreen:!negScreen}"></k-header>
          <section class="workspace" ref="tWorkspace">
            <section class="editor">
              <textarea ref="teacherEditor"></textarea>
            </section>
          </section>
        </div>
        <div class="work" slot='dLeft' @click="chooseScreenLeft">
          <section ref="tItermWrap" :class="['iterm-wrap',{negScreen:!negScreen}]">
            <div class="web-menu"><span>结果展示</span></div>
            <iframe class="resultIframe" frameBorder="0" ref="teacher"></iframe>
          </section>
        </div>
        <div class="work bdl" slot='uRight' @click="chooseScreenRight">
          <k-header :headerData="headerStudent" :class="{negScreen:negScreen}">
            <span class="live-btn" @click="issueQA">提问</span>
            <!--<span v-show="!isLive" class="beforeLiving">未开始</span>
            <span v-show="isLive" class="underLiving ">正在进行中...</span>-->
            <span class="live-btn t-clear" @click="clearCode">清除代码</span>
            <span class="live-btn t-clear" @click="exportCode">导出代码</span>
          </k-header>
          <div class="workspace" ref="sWorkspace">
            <section class="editor">
              <textarea ref="studentEditor"></textarea>
            </section>
          </div>
        </div>
        <div class="work bdl" slot='dRight' @click="chooseScreenRight">
          <browser :options="browserOption" :code="editorContent" @insertCodeSnippet="insertData" :class="{negScreen:negScreen}"></browser>
        </div>
      </drag>
      <div class="countdown" ref="countdown" v-show="countdown">
       <h1>{{count}}</h1>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/addon/hint/show-hint'
import 'codemirror/addon/hint/html-hint'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/theme/base16-dark.css'

import kHeader from '@/components/Header'
import Browser from '@/components/Browser'
import Drag from '@/components/Drag'
import IO from 'socket.io-client'
import { url } from '@/config/url_config'
import { launchFullScreen, exitFullscreen, isPC, RestoreAction, insertLibrary, exportFile } from '@/utils/utils'
import { getUrlParam } from '@/common/js/utils'
import EventBus from '@/views/eventBus'
export default {
  components: {
    Drag,
    kHeader,
    Browser
  },
  data () {
    return {
      headerTeacher: {
        role: '教学区',
        roomId: this.$route.params.roomId
      },
      headerStudent: {
        role: '编辑区'
      },
      isFullscreen: 0,
      count: 3,
      items: [
        {library: '图片'},
        {library: 'jQuery.js'},
        {library: 'Bootstrap.js'},
        {library: 'Bootstrap.css'},
        {library: 'HTML基本结构'}
      ],
      browserOption: {
        role: 1
      },
      onlineStatus: 1,
      isLive: false,
      isHandle: true,
      negScreen: true,
      dropDown: false,
      isConsole: false,
      countdown: false,
      editorContent: '',
      techEditorContent: ''
    }
  },
  mounted () {
    this.initCodeMirror()
    this.initSocket()
  },
  methods: {
    chooseScreenLeft () {
      this.negScreen = true
    },
    chooseScreenRight () {
      console.log('chooseScreenRight')
      this.negScreen = false
    },    
    initCodeMirror () {
      let _this = this
      let configData = {
        autofocus: true,
        lineNumbers: true,
        matchBrackets: true,
        autoCloseBrackets: true,
        tabSize: 4,
        mode: 'text/html',
        line: true
      }
      let teacherConfig = {
        autofocus: true,
        lineNumbers: true,
        matchBrackets: true,
        autoCloseBrackets: true,
        tabSize: 4,
        mode: 'text/html',
        line: true,
        readOnly: true
      }
      const teacherEditor = this.teacherEditor = CodeMirror.fromTextArea(this.$refs.teacherEditor, teacherConfig)

      const studentEditor = this.studentEditor = CodeMirror.fromTextArea(this.$refs.studentEditor, configData)

      CodeMirror.on(teacherEditor, 'change', function (instance, changeObj) {
        _this.techEditorContent = instance.getValue()
        if (!_this.isHandle) {
          _this.showView('teacher', instance.getValue())
        }
      })

      CodeMirror.on(studentEditor, 'change', function (instance, changeObj) {
        _this.editorContent = instance.getValue()
      })
      console.log(this.teacherEditor)
    },
    initSocket () {
      let _this = this
      this.socket.on('clear.code', (data) => {
        console.log('clear.code', data)
        this.teacherEditor.setValue('')
      })
      this.socket.on('init.room.data', (data) => {
        console.log('************************')
        console.log('init.room.data', data)
        _this.teacherEditor.setValue(data.editorContent)
        if (data.isLive) {
          _this.isLive = true
        }
      })

      this.socket.on('action.code', (data) => {
        console.log('--=------')
        console.log('action.code', _this.teacherEditor)
        RestoreAction(_this.teacherEditor, data)
      })

      this.socket.on('start.live', () => {
        _this.countdown = true
        _this.isLive = true
        // 倒计时
        var countdown = setInterval(() => {
          console.log(_this.count)
          _this.count--
          if (_this.count === -1) {
            _this.countdown = false
            clearInterval(countdown)
            _this.count = 3
          }
        }, 1000)
      })

      this.socket.on('check.handle.run', function (data) {
        console.log('data--------', data)
        _this.isHandle = data
      })

      this.socket.on('handle.run', function (data) {
        console.log('data--------', data)
        _this.showView('teacher', _this.techEditorContent)
      })

      this.socket.on('clear.editor', function () {
        _this.isLive = false
        _this.teacherEditor.setValue('')
      })
    },
    showView (role, code) {
      if (role === 'teacher') {
        var iframe = this.$refs.teacher, doc;
      } else if (role === 'student') {
        var iframe = this.$refs.student, doc;
      }

      if(iframe.contentDocument){
        doc = iframe.contentDocument;
      }else if(iframe.contentWindow){
        doc = iframe.contentWindow.document;
      }else{
        doc = iframe.document;
      }

      doc.open()
      doc.writeln(code)
      doc.close()
    },
    quickImport (index) {
      let editor = this.studentEditor
      insertLibrary(index, editor)
      this.$refs.dropDown.style.display = 'none'
      this.dropDown = false
    },
    insertData(index) {
      console.log('index', index)
      let editor = this.studentEditor
      insertLibrary(index, editor)
    },
    clearCode() {
      this.studentEditor.setValue('')
      EventBus.$emit('clearResult')
      this.$store.commit('clearCode', '')
    },
    exportCode() {
      var content = this.studentEditor.getValue()
      var filename = 'practice.html'
      exportFile(content, filename)
    },
    issueQA() {
      let data = {
        roomId: this.$route.params.roomId,
        name: getUrlParam('name'),
        code: this.studentEditor.getValue()
      }
      console.log(data)
      this.socket.emit('student.qa', data)
      this.$success('您的代码已提交给老师')
    }
  }
}
</script>

<style lang="scss">
  .darg-wrap{
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 0;

    .work{
      width: 100%;
      height: 100%;
    }

    .negScreen{
      background: #F0F3F5;

      .info{
        span{
         color: #000;
        }
      }
      .action{
        span{
         color: #000;
        }
        .full-screen{
          img{
            display:none
          }
          background:url(../../assets/fullscreen_gray.png)
        }
      }
      .web-menu{
        background: #F0F3F5 !important;
        color:#000;

        span{
          line-height: 32px;
        }

        .web-iterm{
          color: #3D474D;
          background: url(../../assets/Triangle.png) no-repeat scroll 136px center transparent;
          border-color: #3D474D; 
          a{
            color:#000
          }         
        }
        
        .active{
          background: rgba(61, 71, 77, 0.4);
          color: #fff;
          box-shadow: 0 0;
        }
        li{
          color: #000; 
        }
        li:hover{
          background: rgba(61, 71, 77, 0.4)!important;
          color: #fff;
          box-shadow: 0 0;
        }

        .compile-btn{
          background: rgba(61, 71, 77, 0.4);
          box-shadow: 0 0;
          border-color: rgba(61, 71, 77, 0.4);
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// web_student.vue?5d208c8a